import React from "react";
import ReactDOM from "react-dom";
import classes from "../signin_info_modal/signin_info_modal.module.css";
import util from "../../../styles/utilities.module.css";
import { Link } from "react-router-dom";

const InActiveInfoModal = ({
    isOpen,
    continueHandler,
    message = `Your account is no longer active. If you believe this is a mistake, please contact `,
    heading = null,
    btnText = null,
    email = `support@classgenius.ai`
}) => {

    if (!isOpen) {
        return null;
    }

    return ReactDOM.createPortal(
        <div className={classes["modal-overlay"]}>
            <div className={classes.modal}>
                {heading ? <h3 style={{marginBottom: '15px', fontWeight: 700}}>{heading}</h3> : null}
                <p className={classes.text}>
                    {message}
                    <Link>{email}</Link>.
                </p>
                <div className={classes.confirmationBtnContainer} style={{ justifyContent: 'center' }}>
                    <button onClick={continueHandler} type="button" className={util.btn}>{btnText ? btnText : 'Okay'}</button>
                </div>
            </div>
        </div>,
        document.body
    );
};

export default InActiveInfoModal;
